import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import NudgesEntity from "../entities/NudgesEntity";

export interface NudgesState {
    nudges: NudgesEntity | null;
}

const createInitialState = (): NudgesState => ({
    nudges: null,
});

@singleton()
@StoreConfig({ name: "NudgesStore" })
class NudgesStore extends BaseStore<NudgesState> {
    constructor() {
        super(createInitialState());
    }
}

export default NudgesStore;
